import isSSR from '@/utils/isSSR'
import { ClientModel } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'

const getClientLocale = (clientModel: ClientModel) => {
  return isSSR()
    ? clientModel.locale
    : window?.localStorage?.getItem('i18n-language-code') ||
        clientModel?.locale ||
        'es'
}

export default getClientLocale
